import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconDropdown(props: IconProps) {
  return (
    <BaseIcon {...props} viewBox="0 0 24 24">
      <path
        d="M11.2136 14.6758C11.627 15.1081 12.373 15.1081 12.7864 14.6758L16.7487 10.5324C17.3245 9.93027 16.8472 9 15.9623 9H8.03769C7.15285 9 6.67549 9.93027 7.25134 10.5324L11.2136 14.6758Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
